import { allowedExtensions, allowedFileTypes, FileExtension, FileType } from '../../common/constants';

export const isValidFileType = (file: File): boolean => {
  const fileExtension = file.name.toLowerCase().substring(file.name.lastIndexOf('.'));
  const isValidExtension = allowedExtensions.includes(fileExtension as FileExtension);
  const isValidMimeType = allowedFileTypes.includes(file.type.toLowerCase() as FileType);
  return isValidExtension || isValidMimeType;
};
